module.exports = __webpack_public_path__ + "img/zhxy_image_9.03cf1888.png";